if (!customElements.get('pickup-availability-simple')) {
    customElements.define(
      'pickup-availability-simple',
      class PickupAvailability extends HTMLElement {
        constructor() {
          super();
  
          if (!this.hasAttribute('available')) return;
  
          this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
          this.onClickRefreshList = this.onClickRefreshList.bind(this);
          this.fetchAvailability(this.dataset.variantId);
        }
  
        fetchAvailability(variantId) {
          let rootUrl = this.dataset.rootUrl;
          if (!rootUrl.endsWith('/')) {
            rootUrl = rootUrl + '/';
          }
          const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability-simple`;
  
          fetch(variantSectionUrl)
            .then((response) => response.text())
            .then((text) => {
              const sectionInnerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.shopify-section');
              this.renderPreview(sectionInnerHTML);
            })
            .catch((e) => {
              const button = this.querySelector('button');
              if (button) button.removeEventListener('click', this.onClickRefreshList);
              this.renderError();
            });
        }
  
        onClickRefreshList(evt) {
          this.fetchAvailability(this.dataset.variantId);
        }
  
        renderError() {
          this.innerHTML = '';
          this.appendChild(this.errorHtml);
  
          this.querySelector('button').addEventListener('click', this.onClickRefreshList);
        }
  
        renderPreview(sectionInnerHTML) {
          const drawer = document.querySelector('pickup-availability-drawer');
          if (drawer) drawer.remove();
          if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
            this.innerHTML = '';
            this.removeAttribute('available');
            return;
          }
  
          this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
          this.setAttribute('available', '');
  
          document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
          const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
          colorClassesToApply.forEach((colorClass) => {
            document.querySelector('pickup-availability-drawer').classList.add(colorClass);
          });
  
          const button = this.querySelector('button');
          if (button)
            button.addEventListener('click', (evt) => {
              document.querySelector('pickup-availability-drawer').show(evt.target);
            });
        }
      }
    );
  }
  
  if (!customElements.get('pickup-availability-drawer')) {
    customElements.define(
      'pickup-availability-drawer',
      class PickupAvailabilityDrawer extends HTMLElement {
        constructor() {
          super();
  
          this.onBodyClick = this.handleBodyClick.bind(this);
  
          this.querySelector('button').addEventListener('click', () => {
            this.hide();
          });
  
          this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
          });

          this.initRail();
        }

        // Horizontal store-card rail: prev/next buttons + progress bar
        initRail() {
          const rail = this.querySelector('.pickup-availability-list');
          const nav = this.querySelector('[data-pickup-rail-nav]');
          if (!rail || !nav) return;
          const prev = nav.querySelector('[data-rail-prev]');
          const next = nav.querySelector('[data-rail-next]');
          const bar = nav.querySelector('[data-rail-bar]');
          const cards = rail.querySelectorAll('.pickup-store-card');
          if (cards.length < 2) {
            nav.hidden = true;
            return;
          }

          const update = () => {
            const max = rail.scrollWidth - rail.clientWidth;
            const ratio = max > 0 ? rail.scrollLeft / max : 0;
            if (bar) {
              bar.style.width = `${100 / cards.length}%`;
              bar.style.transform = `translateX(${ratio * (cards.length - 1) * 100}%)`;
            }
            if (prev) prev.disabled = rail.scrollLeft <= 2;
            if (next) next.disabled = max <= 2 || rail.scrollLeft >= max - 2;
          };

          const step = () => {
            const card = cards[0];
            const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
            return card.getBoundingClientRect().width + gap;
          };

          if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
          if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
          rail.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update);
          update();
        }
  
        handleBodyClick(evt) {
          const target = evt.target;
          if (
            target != this &&
            !target.closest('pickup-availability-drawer') &&
            target.id != 'ShowPickupAvailabilityDrawer'
          ) {
            this.hide();
          }
        }
  
        hide() {
          this.removeAttribute('open');
          document.body.removeEventListener('click', this.onBodyClick);
          document.body.classList.remove('overflow-hidden');
          removeTrapFocus(this.focusElement);
        }
  
        show(focusElement) {
          this.focusElement = focusElement;
          this.setAttribute('open', '');
          document.body.addEventListener('click', this.onBodyClick);
          document.body.classList.add('overflow-hidden');
          trapFocus(this);
        }
      }
    );
  }
  